import React from 'react';
import { PlanSpacesLayout } from '../space/organisms';
import { SubscribedPlanTemplate } from './SubscribedPlanTemplate';
export const SubscribePlanSection = () => {
  return <PlanSpacesLayout activeType={'plan'} data-sentry-element="PlanSpacesLayout" data-sentry-component="SubscribePlanSection" data-sentry-source-file="SubscribePlanSection.tsx">
      <SubscribedPlanTemplate data-sentry-element="SubscribedPlanTemplate" data-sentry-source-file="SubscribePlanSection.tsx" />
    </PlanSpacesLayout>;
};